// In-panel how-it-works: lead, a worked story, kamu vs anggota, then
// neighboring features so Playbook is not mistaken for Program or Project.
import React from 'react';
import { Theme, themeColors } from '../theme/colors';

export interface TeamGuideColumn {
  title: string;
  steps: string[];
}

export interface TeamGuideRelated {
  name: string;
  body: string;
}

export interface TeamGuideFaq {
  q: string;
  a: string | string[];
}

export interface TeamGuideProps {
  theme: Theme;
  lead: string | string[];
  exampleName?: string;
  exampleBody?: string | string[];
  steps?: string[];
  columns?: TeamGuideColumn[];
  faqs?: TeamGuideFaq[];
  related?: TeamGuideRelated[];
}

function eyebrowStyle(ink3: string): React.CSSProperties {
  return {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: ink3,
    marginBottom: '6px',
  };
}

const TeamGuide: React.FC<TeamGuideProps> = ({
  theme,
  lead,
  exampleName,
  exampleBody,
  steps,
  columns,
  faqs,
  related,
}) => {
  const c = themeColors[theme];
  const leads = Array.isArray(lead) ? lead : [lead];
  const story = exampleBody == null ? [] : Array.isArray(exampleBody) ? exampleBody : [exampleBody];
  const label = eyebrowStyle(c.ink3);

  return (
    <div style={{ display: 'grid', gap: '18px' }}>
      <div style={{ display: 'grid', gap: '10px' }}>
        {leads.map((p) => (
          <div key={p} style={{ fontSize: '13.5px', color: c.ink, lineHeight: 1.7 }}>
            {p}
          </div>
        ))}
      </div>

      {(exampleName || story.length > 0) && (
        <div>
          <div style={label}>Contoh</div>
          {exampleName && (
            <div style={{ fontSize: '15px', fontWeight: 600, color: c.ink, marginBottom: story.length ? '8px' : 0 }}>
              {exampleName}
            </div>
          )}
          <div style={{ display: 'grid', gap: '8px' }}>
            {story.map((p) => (
              <div key={p} style={{ fontSize: '13px', color: c.ink2, lineHeight: 1.7 }}>
                {p}
              </div>
            ))}
          </div>
        </div>
      )}

      {columns && columns.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '16px',
          }}
        >
          {columns.map((col) => (
            <div key={col.title}>
              <div style={label}>{col.title}</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'grid', gap: '8px' }}>
                {col.steps.map((step) => (
                  <li key={step} style={{ fontSize: '13px', color: c.ink2, lineHeight: 1.65 }}>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      )}

      {steps && steps.length > 0 && (
        <ol style={{ margin: 0, paddingLeft: '18px', display: 'grid', gap: '8px' }}>
          {steps.map((step) => (
            <li key={step} style={{ fontSize: '13px', color: c.ink2, lineHeight: 1.65 }}>
              {step}
            </li>
          ))}
        </ol>
      )}

      {faqs && faqs.length > 0 && (
        <div style={{ display: 'grid', gap: '16px' }}>
          {faqs.map((item) => {
            const answers = Array.isArray(item.a) ? item.a : [item.a];
            return (
              <div key={item.q}>
                <div style={{ fontSize: '13.5px', fontWeight: 600, color: c.ink, marginBottom: '6px' }}>
                  {item.q}
                </div>
                <div style={{ display: 'grid', gap: '8px' }}>
                  {answers.map((p) => (
                    <div key={p} style={{ fontSize: '13px', color: c.ink2, lineHeight: 1.7 }}>
                      {p}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {related && related.length > 0 && (
        <div>
          <div style={label}>Bedanya dengan yang lain</div>
          <div style={{ display: 'grid', gap: '10px' }}>
            {related.map((item) => (
              <div key={item.name} style={{ fontSize: '13px', color: c.ink2, lineHeight: 1.65 }}>
                <strong style={{ color: c.ink, fontWeight: 600 }}>{item.name}.</strong>{' '}
                {item.body}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamGuide;
